import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { syncAuthValid } from '@actions/auth-actions';
import {
  authSelector,
  CROSS_TAB_AUTH_UPDATES,
  onAuthLoginUpdate
} from '@utils/auth-utils';


const useWatchAuthCrossTab = () => {
  const location = useLocation();
  const { defaultUrl } = useSelector(state => state.config);
  const dispatch = useDispatch();

  // Syncs authValid on mount (e.g. due to having a valid cookie auth on load)
  useEffect(() => {
    dispatch(syncAuthValid(location, defaultUrl));
  }, [dispatch, location, defaultUrl]);

  // Syncs authValid whenever another tab notifies an auth login state change
  useEffect(() => {
    return onAuthLoginUpdate(() => dispatch(syncAuthValid(location, defaultUrl)));
  }, [dispatch, location, defaultUrl]);
};

// Legacy mode auth checks, if BroadcastChannel is not available
const useWatchAuthOnState = () => {
  const location = useLocation();
  const { defaultUrl } = useSelector(state => state.config);
  const stateAuthValid = useSelector(state => state.auth.valid || false);
  // This executes authSelector on every state change
  // It is legacy behavior to behave as connectedReduxRedirect was previously hooked up
  const tokenAuthValid = useSelector(authSelector);
  const dispatch = useDispatch();

  
  // Syncs authValid on mount (e.g. due to having a valid cookie auth on load)
  useEffect(() => {
    dispatch(syncAuthValid(location, defaultUrl));
  }, [dispatch, location, defaultUrl]);

  useEffect(() => {
    if (stateAuthValid !== tokenAuthValid) {
      dispatch(syncAuthValid(location, defaultUrl));
    }
  }, [dispatch, stateAuthValid, tokenAuthValid, location, defaultUrl]);
};

export const useWatchAuth = CROSS_TAB_AUTH_UPDATES ? useWatchAuthCrossTab : useWatchAuthOnState;
